import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./ForgotPassword.module.css";
import "../../fonts/Futura-PT-Book.ttf";
import { useNavigate } from "react-router-dom";
const ForgotPassword = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [input, setinput] = useState("");
  const [emptyInput, setEmptyInput] = useState(false);
  const submit = async () => {
    if (input === "") {
      setEmptyInput(true);
    }
    const response = await fetch(`${backend_base}/user/forgotpass`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: input,
      }),
    });
    const data = await response.json();
    if (response.status === 200 || response.status === 201) {
      console.log("Successfully set the forgot password");
      console.log(data);
      navigate("/forgotpassword-success");
    } else {
      alert("Error");
    }
  };
  return (
    <div>
      <Header />
      <div className={styles.id}>
        <div className={styles.id_content}>
          <h6 className={styles.id_title}>仮パスワード発行</h6>
          <h6 className={styles.id_subtitle}>
            下記に仮パスワードを発行します。
          </h6>
          <h6 className={styles.id_thirdTitle}>
            Eメールアドレスを入力してください。
          </h6>
          <div className="text-center">
            <input
              onChange={(e) => {
                if (e.target.value === "") {
                  setEmptyInput(true);
                } else {
                  setEmptyInput(false);
                }
                setinput(e.target.value);
              }}
              value={input}
              className={styles.id_input}
              type="text"
              placeholder="Email Address"
            />
          </div>
          {emptyInput && <div className={styles.error}>※必須入力項目です</div>}
          <div className="text-center">
            <button onClick={submit} className={styles.id_button}>
              Send
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
